import { Outlet } from 'react-router-dom';

import { Erro403Page } from '@/app/erros/Erro403Page';
import { EstadoCarregando } from '@/shared/components/estados';
import type { PermissaoChave } from '@/shared/permissoes/chaves';
import { usePermissoes } from '@/shared/permissoes/usePermissoes';

interface Props {
  /** Basta UMA destas chaves para liberar a rota. */
  exigidas: readonly PermissaoChave[];
}

/**
 * Guarda de PERMISSÃO — complementa o `PrivateRoute`, que guarda só a SESSÃO.
 *
 * ⚠️ **Renderiza a tela 403; não redireciona.** Mandar para o login quem já
 * está logado é a mensagem errada — o usuário conclui que a sessão caiu e
 * tenta entrar de novo, quando o problema é que o cargo dele não tem a chave.
 *
 * Como fica aninhado dentro do `AppLayout`, o 403 aparece **com sidebar e
 * header**: o usuário vê onde está e para onde pode ir.
 */
export function RotaComPermissao({ exigidas }: Props) {
  const { podeAlguma, carregando } = usePermissoes();

  // Sem isto, o 403 pisca antes de o `/me` responder — e um 403 falso é pior
  // que um spinner.
  if (carregando) return <EstadoCarregando />;

  if (!podeAlguma(exigidas)) return <Erro403Page />;

  return <Outlet />;
}
